export default function IconXlsFile () {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.97847 1.38877V5.40719H1.11108V15.7405H3.97847V18.6109H18.8889V1.38867L3.97847 1.38877ZM3.97847 8.27766H5.49818L6.27243 9.42571L7.04667 8.27766H8.56618L7.04646 10.574L8.56618 12.8704H7.04646L6.27243 11.7223L5.49818 12.8704H3.97847L5.49818 10.574L3.97847 8.27766ZM17.7419 17.4628H5.12542V15.7405H11.4337V12.2961H16.0216V11.1481L11.4337 11.1479V9.99984H16.0216V8.85179H11.4337V7.70375H16.0216V6.5557L11.4337 6.5555V5.40746L5.12542 5.40726V2.53689H17.7419V17.4628Z"
        fill="#377147"/>
    </svg>


  )
}
